import React, { useState } from 'react';
import {
  Card,
  Form,
  Input,
  Space,
  Button,
  Row,
  Col,
  Select,
  Typography,
  InputNumber,
  Checkbox,
} from 'antd';
import traderService from '../../services/TraderService';
import securityService from '../../services/SecurityService';
import placeOrderService from '../../services/PlaceOrderService';
import { useAuth } from '../../hooks/useAuth';
import { useEffect } from 'react';
const { Title } = Typography;

const PlaceOrder = () => {
  // Form control
  const [form] = Form.useForm();
  const { showNotification } = useAuth();
  const [requiredMark, setRequiredMarkType] = useState('');
  const [tradingAccountNo, setTradingAccountNo] = useState('');
  const [securities, setSecurities] = useState([]);
  const [disabledPrice, setDisabledPrice] = useState(false);
  const [loading, setLoading] = useState(false);

  const symbolCode = securities.map(item => item.symbolCode).sort();

  const onRequiredTypeChange = ({ tradingAccountNo, symbolCode, orderPriceType }) => {
    // setRequiredMarkType(requiredMarkValue);
    if (tradingAccountNo) setTradingAccountNo(tradingAccountNo);

    if (symbolCode) {
      let security = securities.find(security => security.symbolCode === symbolCode);
      form.setFieldsValue({
        securityName: security.securityName,
        securityCode: security.securityCode,
        isinCode: security.isinCode,
      });
    }

    if (orderPriceType) {
      if (orderPriceType === 'MARKET') {
        form.setFieldsValue({ price: null });
        setDisabledPrice(true);
      } else {
        setDisabledPrice(false);
      }
    }
  };

  useEffect(() => {
    const getSecurities = async () => {
      setLoading(true);
      let response = await securityService.getSecurities();
      setLoading(false);
      if (response.success) setSecurities(response.securityDataList);
      else showNotification('error', response.message);
    };
    getSecurities();
  }, []);

  const onFinish = async formValues => {
    // will connect with API
    //   {
    //     "tradingAccountNo": "202000002",
    //     "primaryEmail": "thaw.tar.khin@manulife.com",
    //     "traderName": "MANULIFE MYANMAR LIFE INSURANCE COMPANY LIMITED",
    //     "clientType": "FOREIGN_CORPORATE",
    //     "symbolCode": "FPB",
    //     "securityCode": "000040000",
    //     "securityName": "First Private Bank Ltd.",
    //     "isinCode": "MM0000400000",
    //     "orderType": "BUY",
    //     "quantity": "2",
    //     "orderPriceType": "MARKET",
    //     "price": null
    // }
    console.log(formValues.preOrder);
    const payload = {
      tradingAccountNo: formValues.tradingAccountNo,
      securityCode: formValues.securityCode,
      price: formValues.price,
      orderPriceType: formValues.orderPriceType,
      initiatedQuantity: formValues.quantity,
      preOrder: formValues.preOrder,
    };

    if (formValues.orderType === 'BUY') {
      await placeBuyOrder(payload);
    } else {
      await placeSellOrder(payload);
    }
  };

  const placeBuyOrder = async payload => {
    setLoading(true);
    let response = await placeOrderService.placeBuyOrder(payload);

    console.log(response);
    setLoading(false);
    if (response.success) {
      showNotification('success', response.message + ' Order No: ' + response.orderId);
      form.resetFields();
    } else showNotification('error', response.message);
  };

  const placeSellOrder = async payload => {
    setLoading(true);
    let response = await placeOrderService.placeSellOrder(payload);
    setLoading(false);
    if (response.success) {
      showNotification('success', response.message + ' Order No: ' + response.orderId);
      form.resetFields();
    } else showNotification('error', response.message);
  };

  const findTrader = async () => {
    let response = await traderService.findTrader({ tradingAccountNo: tradingAccountNo });

    if (response.success)
      form.setFieldsValue({
        traderName: response.name,
        clientType: response.clientType,
        primaryEmail: response.primaryEmail,
      });
    else showNotification('error', response.message);
  };

  return (
    <Space direction="vertical" size={'large'} style={{ width: '100%' }}>
      <Title level={4} style={{ margin: 0 }}>
        Place Order (Buy & Sell)
      </Title>
      <Form
        onFinish={onFinish}
        form={form}
        labelCol={{
          span: 8,
          lg: {
            span: 12,
          },
          xl: {
            span: 12,
          },
        }}
        onValuesChange={onRequiredTypeChange}
        requiredMark={requiredMark}
      >
        <Space direction="vertical" size={'large'} style={{ width: '100%' }}>
          <Card title="Trader" headStyle={{ backgroundColor: '#eaeaea' }}>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  label="Trading Account No"
                  name={'tradingAccountNo'}
                  rules={[
                    {
                      required: true,
                      message: 'Please do not leave blank',
                    },
                  ]}
                >
                  {/* <Input/> */}
                  <Space.Compact
                    style={{
                      width: '100%',
                    }}
                  >
                    <Input size="middle" />
                    <Button type="primary" onClick={findTrader}>
                      Check
                    </Button>
                  </Space.Compact>
                </Form.Item>
                <Form.Item
                  label="Primary Email"
                  name={'primaryEmail'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please do not leave blank',
                  //   },
                  // ]}
                >
                  <Input defaultValue={''} size="middle" disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  label="Trader Name"
                  name={'traderName'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please do not leave blank',
                  //   },
                  // ]}
                >
                  <Input defaultValue={''} size="middle" disabled />
                </Form.Item>
                <Form.Item
                  label="Client Type"
                  name={'clientType'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please do not leave blank',
                  //   },
                  // ]}
                >
                  <Input defaultValue={''} size="middle" disabled />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card title="Security" headStyle={{ backgroundColor: '#eaeaea' }}>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  label="Symbol Code"
                  name={'symbolCode'}
                  rules={[
                    {
                      required: true,
                      message: 'Please do not leave blank',
                    },
                  ]}
                >
                  <Select size="middle">
                    {symbolCode.map((item, index) => (
                      <Select.Option key={index} value={item}>
                        {item}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Security Code"
                  name={'securityCode'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please do not leave blank',
                  //   },
                  // ]}
                >
                  <Input defaultValue={''} size="middle" disabled />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  label="Security Name"
                  name={'securityName'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please do not leave blank',
                  //   },
                  // ]}
                >
                  <Input defaultValue={''} size="middle" disabled />
                </Form.Item>
                <Form.Item
                  label="ISIN Code"
                  name={'isinCode'}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please do not leave blank',
                  //   },
                  // ]}
                >
                  <Input defaultValue={''} size="middle" disabled />
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Card title="Order" headStyle={{ backgroundColor: '#eaeaea' }}>
            <Row gutter={16}>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  label="Buy/Sell"
                  name={'orderType'}
                  rules={[
                    {
                      required: true,
                      message: 'Please do not leave blank',
                    },
                  ]}
                >
                  <Select size="middle">
                    <Select.Option value="BUY">BUY</Select.Option>
                    <Select.Option value="SELL">SELL</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Quantity"
                  name={'quantity'}
                  rules={[
                    {
                      required: true,
                      message: 'Please do not leave blank',
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    min={1}
                    formatter={value => Number(value).toLocaleString('en-US')}
                    parser={value => Number(value.toString().split(',').join(''))}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <Form.Item
                  label="Market/Limit"
                  name={'orderPriceType'}
                  rules={[
                    {
                      required: true,
                      message: 'Please do not leave blank',
                    },
                  ]}
                >
                  <Select size="middle">
                    <Select.Option value="MARKET">MARKET</Select.Option>
                    <Select.Option value="LIMIT">LIMIT</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Price"
                  name={'price'}
                  rules={[
                    {
                      required: !disabledPrice,
                      message: 'Please do not leave blank',
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: '100%' }}
                    min={1}
                    disabled={disabledPrice}
                    formatter={value => Number(value).toLocaleString('en-US')}
                    parser={value => Number(value.toString().split(',').join(''))}
                  />
                  {/* <Input disabled={disabledPrice} size="middle" /> */}
                </Form.Item>
                <Form.Item
                  label="Pre Order"
                  name="preOrder"
                  valuePropName="checked"
                  // wrapperCol={{ offset: 8, span: 16 }}
                >
                  <Checkbox></Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </Card>

          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{ float: 'right' }}
            loading={loading}
          >
            Order
          </Button>
        </Space>
      </Form>
    </Space>
  );
};

export default PlaceOrder;
